/**
 * Reading feature API client — delegates to the shared apiClient.
 *
 * All reading API files import `fetchAPI` from here, so this is the
 * single point where auth, credentials, 401 retry, and ID normalization
 * are wired in for the entire reading feature.
 */

import { apiClient } from "@/shared/lib/api/client";

export const fetchAPI = apiClient;
